import Table from './table/table';
import { TABLE } from './constants';
import { Rect } from 'konva/lib/shapes/Rect';

class Zone {
	resources: Table[] = [];
	color: string = 'lime';
	id: any = 0;
	rects: Rect[] = [];

	constructor(tables: Table[], color: string, id?: number | any) {
		this.resources = tables;
		this.id = id;
		this.color = color;
		this.init();
	}

	init() {
		const offset = 20;

		const rect = new Rect({
			x: 0,
			y: 0,
			opacity: 0.8,
			width: 25,
			height: 25,
			fill: this.color,
		});

		this.resources.forEach(table => {
			const clone = rect.clone();
			table.draggable = false;
			clone.x(0);
			clone.y(0);
			clone.width(table.shape.width() + offset * 2);
			clone.height(table.shape.height() + offset * 2);
			table.element.add(clone);
			table.zoneHighlight = clone;
			table.element.children[table.element.children.length - 1].zIndex(0);

			if (table.options.form == TABLE.FORMS.QUAD) {
				clone.x(-20);
				clone.y(-20);
			}

			if (table.options.form == TABLE.FORMS.CIRCLE) {
				clone.x(-table.shape.radius() - 20);
				clone.y(-table.shape.radius() - 20);
			}

			this.rects.push(clone);
		});

		this.initId(rect._id);
	}

	private initId(rectID: number) {
		this.id = this.id || rectID;
	}

	remove() {
		this.hide();
		this.rects.forEach(r => {
			r.off();
			r.remove();
		});
	}

	hide() {
		this.resources.forEach((t: any) => t.zoneHighlight.hide());
	}
	show() {
		this.resources.forEach((t: any) => t.zoneHighlight.show());
	}
}

export default Zone;
